/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {LOADER_STATUS, GET_URL} from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  url:''
};


/* eslint-disable default-case, no-param-reassign */
const getPresignedUrl = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case GET_URL:
        return {
          ...state,
          url:action.payload
        }
        default:
          return state;
    }
  };

export default getPresignedUrl;
